import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { Product } from '../../domain/dtos/product.dto'
import { QueryKey } from '../../domain/enums/query-key.enum'
import { GetProduct } from '../../usecases/get-product.usecase'

export const useGetProduct = (productId: string) => {
  const container = useContainer()

  return useQuery<Product>(
    [QueryKey.getProduct, productId],
    () => new GetProduct(container.get(HttpClient)).execute(productId),
    {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!productId,
    },
  )
}
